import React from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import {
  asyncActionError,
  asyncActionFinish,
  asyncActionStart,
} from "../../../app/async/asyncReducer";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { deleteDocFromFirestore } from "../../../app/firestore/firestoreService";
import { closeModal } from "../../../app/common/modals/modalReducer";
import { FIRESTORE_REQUEST_DELETE_ACCOUNTS_COLLECTION } from "../../../app/firestore/firestoreConstants";
import { Button } from "semantic-ui-react";

export default function AccountDeletionRequestModal({ request }) {
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state.async);

  async function handleDeleteAccountButton() {
    try {
      dispatch(asyncActionStart());
      await deleteDocFromFirestore({
        dbCollection: FIRESTORE_REQUEST_DELETE_ACCOUNTS_COLLECTION,
        id: request.id,
      });
      dispatch(asyncActionFinish());
      dispatch(closeModal());
    } catch (error) {
      dispatch(
        asyncActionError({
          code: "delete-request-account-error",
          message: "Could not delete item",
        })
      );
      toast.error(error.message);
    }
  }

  return (
    <ModalWrapper
      style={{ paddingLeft: 0, width: 400 }}
      modalClassName="modal-ux-wrapper"
      padding={30}
    >
      <div className="body-blue-text" style={{ marginBottom: 20 }}>
        Reminder: Has this account been deleted from lookup first?
      </div>
      <Button
        className="overwrite-button cta-orange"
        content={"Yes, account deleted"}
        onClick={handleDeleteAccountButton}
        loading={loading}
      />
    </ModalWrapper>
  );
}
